import { Link } from "@mui/material";
import { Link as RouterLink } from "react-router";

import type { UseMomentProperties } from "../moment-card/types";
import type { FC } from "react";

export const MomentTitleLink: FC<{
  moment: Pick<UseMomentProperties, "id" | "title" | "follow_up">;
}> = ({ moment }) => (
  <Link
    component={RouterLink}
    to={moment.follow_up?.id ? `/follow-up/${moment.follow_up.id}` : `/moments/${moment.id ?? ""}`}
    color="inherit"
    underline="hover"
  >
    {moment.title}
  </Link>
);
